import { useEffect, useState } from "react"
import Value from "aldoo-ra/Value"
import { usePageContext } from "vike-react/usePageContext"

/**
 * The site's platform (android / ios), as the page renders it: the one the
 * server resolved for the request (`ssrPlatform`: the remembered choice's
 * cookie, else the url, else the user agent) until the page has hydrated,
 * then the visitor's own (PlatformManager, remembered in localStorage).
 * Components that read the platform while rendering use this rather than
 * Value("site_platform"), so the server and the browser's first render show
 * the same page — a mismatch threw the server's HTML away.
 * @returns {[string, Function]} the platform and its setter, as Value gives them
 */
export default function useSitePlatform() {
  const pageContext = usePageContext()
  const [platform, setPlatform] = Value("site_platform")
  const [hydrated, setHydrated] = useState(false)
  useEffect(() => {
    setHydrated(true)
  }, [])
  const ssrPlatform = pageContext?.ssrPlatform
  return [(hydrated && platform) || ssrPlatform || platform, setPlatform]
}
